import { useTranslations } from 'next-intl';
import { InlineButton } from '@//components/InlineButton';
import { Logo } from '@//components/Logo';
import { SuggestionBanner } from '@//components/SuggestionBanner';

interface SuggestionBannerContainerProps {
  description: string;
  logo?: {
    src: string;
    srcSet: string;
    alt: string;
  };
  action: React.ReactNode;
  onReadMore: () => void;
  readMoreTitle?: string;
}

export const SuggestionBannerContainer: React.FC<SuggestionBannerContainerProps> = ({
  description,
  logo,
  action,
  onReadMore,
  readMoreTitle,
}) => {
  const t = useTranslations('other.common');

  return (
    <SuggestionBanner
      logo={
        logo ? (
          <Logo src={logo.src} srcSet={logo.srcSet} alt={logo.alt} width={120} height={48} />
        ) : undefined
      }
      description={description}
      action={action}
      readMoreButton={
        <InlineButton onClick={onReadMore} title={readMoreTitle ?? t('readMore')}>
          {t('readMore')}
        </InlineButton>
      }
    />
  );
};
